import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class EquivalenciaProductoService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    create(inputParams, callback) {
        this.gqlclient.mutate({
            mutation: gql `
        mutation ($entidad: equivalencia_productoInputType) {
          equivalencia_producto {
            agregar(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                id
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.equivalencia_producto.agregar;
            callback({ mensajes, respuesta });
        });
    }
    update(inputParams, callback) {
        this.gqlclient.mutate({
            mutation: gql `
        mutation ($entidad: equivalencia_productoInputType) {
          equivalencia_producto {
            modificar(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                id
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.equivalencia_producto.modificar;
            callback({ mensajes, respuesta });
        });
    }
    obtenerSegunProveedor(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($entidad: equivalencia_productoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          equivalencia_producto {
            obtenerSegunProveedor(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                codigo
                texto
                tipo
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  id
                  empresa_rut
                  sucursal_codigo
                  cliente_proveedor_rut
                  producto_proveedor
                  detalle_producto
                  formato_codigo
                  factor_equivalencia
                  activado
                  observacion
                  producto_codigo
                  producto_sku
                  producto_descripcion
                  formato_codigo_top
                  formato_descripcion_top
                }
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.equivalencia_producto.obtenerSegunProveedor;
            callback({ mensajes, respuesta });
        });
    }
    obtenerSegunId(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($id: Int) {
          equivalencia_producto {
            obtenerSegunId(id: $id) {
              mensajes {
                codigo
                texto
                tipo
              }
              respuesta {
                id
                cliente_proveedor_rut
                producto_codigo
                sucursal_codigo
                formato_codigo
                empresa_rut
                producto_proveedor
                detalle_producto
                activado
                observacion
                fueUsadaEnTransaccion
                producto_sku
                producto_descripcion
                factor_equivalencia
                formato_codigo_top
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.equivalencia_producto.obtenerSegunId;
            callback({ mensajes, respuesta });
        });
    }
    obtenerProductoProveedor(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($entidad: equivalencia_productoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          equivalencia_producto {
            obtenerProductoProveedor(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                codigo
                texto
                tipo
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  id
                  empresa_rut
                  sucursal_codigo
                  cliente_proveedor_rut
                  producto_proveedor
                  detalle_producto
                  formato_codigo
                  factor_equivalencia
                  activado
                  observacion
                  producto_codigo
                  producto_sku
                  producto_descripcion
                  formato_codigo_top
                  formato_descripcion_top
                }
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.equivalencia_producto.obtenerProductoProveedor;
            callback({ mensajes, respuesta });
        });
    }
    eliminarEquivalencia(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        mutation ($entidad: equivalencia_productoInputType) {
          equivalencia_producto {
            eliminarEquivalencia(entidad: $entidad) {
              mensajes {
                codigo
                texto
                tipo
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes } = response.data.equivalencia_producto.eliminarEquivalencia;
            // Para eliminarEquivalencia, si hay mensajes de error, la operación falló
            // Si no hay mensajes o todos son de tipo INFO, la operación fue exitosa
            const hasErrors = mensajes && mensajes.some(m => m.tipo === 'ERROR');
            const respuesta = hasErrors ? null : { success: true };
            callback({ mensajes, respuesta });
        });
    }
}
EquivalenciaProductoService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function EquivalenciaProductoService_Factory() { return new EquivalenciaProductoService(i0.ɵɵinject(i1.GraphQLClient)); }, token: EquivalenciaProductoService, providedIn: "root" });
